// ============================================================================
// SPANISH TRANSLATIONS - CHAPTER 1: EL GÉNESIS
// ============================================================================
// Niveles 1-13 (13 niveles, 39 preguntas)

export const chapter1Translations = {
  name: "El Génesis",
  description: "En el principio... El conocimiento vivifica el espíritu",
  
  spiritualWisdom: {
    principle: "El conocimiento vivifica el espíritu",
    scripture: "Mi pueblo fue destruido, porque le faltó conocimiento (Oseas 4:6)",
    application: "Cada versículo estudiado, cada verdad descubierta nutre nuestra alma y fortalece nuestra fe"
  },
  
  levels: {
    1: {
      name: "La Creación",
      challenge: "En el principio creó Dios los cielos y la tierra...",
      easy: {
        question: "¿En cuántos días creó Dios el mundo?",
        options: ["5 días", "6 días", "7 días", "8 días"],
        hint: "Piensa en el día de descanso de la semana",
        funFact: "💡 El séptimo día, Dios descansó. ¡Es el origen del Sabbat, día de descanso semanal!"
      },
      medium: {
        question: "¿Qué creó Dios el cuarto día?",
        options: ["Los animales", "El hombre", "El sol, la luna y las estrellas", "Las plantas"],
        hint: "Estas creaciones iluminan la tierra y marcan el tiempo",
        funFact: "🌟 ¡Las lumbreras fueron creadas para marcar las estaciones y las fiestas religiosas!"
      },
      hard: {
        question: "¿Qué significa que el hombre fue creado 'a imagen de Dios'?",
        options: [
          "Apariencia física idéntica",
          "Capacidad de crear y amar",
          "Inmortalidad natural",
          "Poder divino"
        ],
        hint: "Se trata de cualidades espirituales e intelectuales",
        funFact: "✨ ¡La imagen de Dios en nosotros incluye creatividad, conciencia moral y capacidad de amar!"
      }
    },
    
    2: {
      name: "La Tentación del Jardín",
      challenge: "La serpiente era astuta, más que todos los animales del campo...",
      easy: {
        question: "¿Qué animal tentó a Eva en el jardín?",
        options: ["El león", "La serpiente", "El águila", "El dragón"],
        hint: "Este animal se arrastra sobre el vientre",
        funFact: "🐍 ¡La serpiente representa la tentación y la astucia en toda la Biblia!"
      },
      medium: {
        question: "¿Qué promesa mentirosa le hace la serpiente a Eva?",
        options: [
          "Seréis inmortales",
          "Seréis ricos",
          "Seréis como dioses",
          "Seréis felices"
        ],
        hint: "La serpiente promete elevación al nivel divino",
        funFact: "🎭 ¡La mentira de la serpiente mezcla verdad y engaño - técnica de tentación clásica!"
      },
      hard: {
        question: "¿Cómo ilumina esta caída nuestra lucha entre el bien y el mal?",
        options: [
          "El mal es más fuerte",
          "El libre albedrío implica responsabilidad",
          "Dios nos abandona",
          "La tentación es invencible"
        ],
        hint: "Se trata de nuestra capacidad de elegir y asumir las consecuencias",
        funFact: "🌳 ¡El árbol del conocimiento simboliza la elección moral que define a la humanidad!"
      }
    },
    
    3: {
      name: "Caín y Abel",
      challenge: "Dos hermanos, dos ofrendas, un drama eterno...",
      easy: {
        question: "¿Quién fue el primer asesino de la historia bíblica?",
        options: ["Abel", "Set", "Caín", "Adán"],
        hint: "El hermano celoso de Abel",
        funFact: "⚡ ¡Caín se convierte en el símbolo de los celos fraternales destructivos!"
      },
      medium: {
        question: "¿Por qué Dios prefirió la ofrenda de Abel?",
        options: [
          "Mayor cantidad",
          "Abel era más hermoso",
          "Ofrecida con corazón sincero",
          "Era carne"
        ],
        hint: "Dios mira el corazón",
        funFact: "❤️ ¡Dios mira el corazón, no solo la apariencia de nuestras acciones!"
      },
      hard: {
        question: "¿Qué nos enseña esta historia sobre los celos?",
        options: [
          "Los celos son naturales",
          "Los celos no controlados llevan a la destrucción",
          "Dios favorece a algunos",
          "La competencia es sana"
        ],
        hint: "Se trata de las consecuencias de no controlar nuestras emociones",
        funFact: "🔥 '¡El pecado está a la puerta' - Dios nos advierte antes de la caída!"
      }
    },

    4: {
      name: "El Diluvio de Noé",
      challenge: "Y llovió sobre la tierra cuarenta días y cuarenta noches...",
      easy: {
        question: "¿Cuántos días y noches duró la lluvia del diluvio?",
        options: ["30 días", "40 días", "50 días", "100 días"],
        hint: "Un número simbólico en la Biblia",
        funFact: "☔ ¡El número 40 simboliza la prueba y la transformación en la Biblia!"
      },
      medium: {
        question: "¿Cuántos animales limpios debía tomar Noé en el arca?",
        options: [
          "1 pareja",
          "2 parejas",
          "7 parejas",
          "10 parejas"
        ],
        hint: "Más que los animales impuros",
        funFact: "🦁 ¡Los animales limpios estaban destinados a los sacrificios después del diluvio!"
      },
      hard: {
        question: "¿Qué simboliza el arca en nuestro camino espiritual?",
        options: [
          "La huida de los problemas",
          "La salvación por la fe y la obediencia",
          "El aislamiento necesario",
          "La superioridad de los creyentes"
        ],
        hint: "Se trata de la salvación ofrecida a los que creen",
        funFact: "🚢 ¡El arca prefigura la salvación: un solo camino para escapar del juicio!"
      }
    },

    5: {
      name: "La Torre de Babel",
      challenge: "Edifiquémonos una torre cuya cúspide llegue al cielo...",
      easy: {
        question: "¿Qué confundió Dios en Babel?",
        options: ["Los planes", "Las lenguas", "Las herramientas", "Los pensamientos"],
        hint: "Lo que permite comunicarse",
        funFact: "🗣️ ¡Babel es el origen mítico de la diversidad lingüística mundial!"
      },
      medium: {
        question: "¿Por qué los hombres querían construir esta torre?",
        options: [
          "Para protegerse",
          "Para vivir juntos",
          "Para hacerse un nombre y alcanzar el cielo",
          "Para honrar a Dios"
        ],
        hint: "Se trata de orgullo y querer igualar a Dios",
        funFact: "🏗️ ¡El orgullo de querer igualar a Dios siempre lleva a la confusión!"
      },
      hard: {
        question: "¿Cómo se manifiesta hoy el orgullo de Babel?",
        options: [
          "Solo en la tecnología",
          "En la voluntad humana de autonomía absoluta sin Dios",
          "En los rascacielos",
          "En las lenguas diferentes"
        ],
        hint: "Se trata de querer prescindir de Dios",
        funFact: "💭 ¡Babel nos recuerda que la unidad sin Dios se convierte en orgullo destructivo!"
      }
    },

    6: {
      name: "El Llamado de Abraham",
      challenge: "Vete de tu tierra y de tu parentela, y de la casa de tu padre...",
      easy: {
        question: "¿Qué edad tenía Abraham cuando dejó su país?",
        options: ["50 años", "65 años", "75 años", "100 años"],
        hint: "Una edad muy avanzada para empezar de nuevo",
        funFact: "🚶 ¡A los 75 años, Abraham comienza una nueva vida - nunca es demasiado tarde!"
      },
      medium: {
        question: "¿Qué triple promesa le hace Dios a Abraham?",
        options: [
          "Riqueza, poder, sabiduría",
          "Tierra, descendencia, bendición universal",
          "Larga vida, paz, prosperidad",
          "Fe, esperanza, amor"
        ],
        hint: "Una promesa que concierne a toda la humanidad",
        funFact: "🌟 ¡La promesa a Abraham concierne a toda la humanidad, no solo a él!"
      },
      hard: {
        question: "¿Qué nos enseña el 'salto de fe' de Abraham?",
        options: [
          "La fe ciega es peligrosa",
          "Seguir a Dios exige soltar nuestras seguridades",
          "Dios favorece a ciertos pueblos",
          "La fe garantiza el éxito"
        ],
        hint: "Se trata de confiar abandonando nuestras referencias",
        funFact: "✨ ¡Abraham es llamado 'padre de la fe' porque creyó sin ver!"
      }
    },

    7: {
      name: "El Sacrificio de Isaac",
      challenge: "Toma ahora tu hijo, tu único, Isaac, a quien amas...",
      easy: {
        question: "¿En qué monte debía Abraham sacrificar a Isaac?",
        options: ["Sinaí", "Moriah", "Carmelo", "Sion"],
        hint: "Este monte se convertirá en un lugar sagrado",
        funFact: "🏔️ ¡El monte Moriah se convertirá en el lugar del Templo de Jerusalén!"
      },
      medium: {
        question: "¿Qué proveyó Dios en lugar de Isaac?",
        options: [
          "Un cordero",
          "Un carnero trabado en un zarzal por sus cuernos",
          "Una cabra",
          "Un toro"
        ],
        hint: "Un animal macho adulto con cuernos",
        funFact: "🐏 ¡El carnero sustituido prefigura el sacrificio sustitutivo final!"
      },
      hard: {
        question: "¿Cómo ilustra esta prueba la fe absoluta?",
        options: [
          "Dios prueba cruelmente",
          "La fe trasciende incluso el amor paternal",
          "Los sacrificios humanos agradan a Dios",
          "Abraham no amaba realmente a Isaac"
        ],
        hint: "Se trata de confiar incluso cuando no entendemos",
        funFact: "💝 ¡Dios siempre provee una salida cuando confiamos en Él!"
      }
    },

    8: {
      name: "Jacob y Esaú",
      challenge: "El mayor servirá al menor...",
      easy: {
        question: "¿Por qué vendió Esaú su primogenitura?",
        options: ["Oro", "Un plato de lentejas", "Ropa", "Vino"],
        hint: "Un plato para satisfacer su hambre",
        funFact: "🍲 ¡Un momento de hambre le costó a Esaú su bendición eterna!"
      },
      medium: {
        question: "¿Cómo engañó Jacob a su padre Isaac?",
        options: [
          "Cambiando su voz",
          "Disfrazándose",
          "Cubriéndose con piel de cabra",
          "Mintiendo sobre su nombre"
        ],
        hint: "Para parecerse a su hermano velludo",
        funFact: "🎭 ¡Isaac, ciego, reconoció el olor y el tacto pero no el engaño!"
      },
      hard: {
        question: "¿Qué revela esta historia sobre nuestras elecciones?",
        options: [
          "El engaño a veces es necesario",
          "Los deseos inmediatos pueden costarnos nuestro destino",
          "Dios aprueba la astucia",
          "El menor siempre es favorecido"
        ],
        hint: "Se trata de las consecuencias de nuestras decisiones impulsivas",
        funFact: "⚖️ ¡Nuestras elecciones impulsivas pueden tener consecuencias eternas!"
      }
    },

    9: {
      name: "El Sueño de Jacob",
      challenge: "Vio una escalera apoyada en tierra, cuya cima tocaba el cielo...",
      easy: {
        question: "¿Qué vio Jacob en su sueño?",
        options: [
          "Un árbol gigante",
          "Una escalera al cielo con ángeles",
          "Un templo",
          "Estrellas"
        ],
        hint: "Un medio de comunicación entre cielo y tierra",
        funFact: "👼 ¡La escalera de Jacob simboliza la conexión entre el Cielo y la Tierra!"
      },
      medium: {
        question: "¿Qué hizo Jacob con la piedra que le servía de almohada?",
        options: [
          "La rompió",
          "La enterró",
          "La erigió y ungió con aceite",
          "Se la llevó"
        ],
        hint: "Hizo de ella un monumento sagrado",
        funFact: "🪨 ¡Esta piedra se convierte en 'Betel' - la casa de Dios!"
      },
      hard: {
        question: "¿Cómo conecta esta visión cielo y tierra en nuestra vida?",
        options: [
          "Solo por los sueños",
          "Por la oración que establece el puente con lo divino",
          "Por los ángeles guardianes",
          "Por los lugares sagrados"
        ],
        hint: "Se trata de nuestra comunicación con Dios",
        funFact: "🌉 ¡La oración es nuestra escalera personal hacia el Cielo!"
      }
    },

    10: {
      name: "José Vendido por sus Hermanos",
      challenge: "He aquí viene el soñador...",
      easy: {
        question: "¿Cuántos hermanos tenía José?",
        options: ["7 hermanos", "10 hermanos", "11 hermanos", "12 hermanos"],
        hint: "Uno menos que el número de tribus de Israel",
        funFact: "👨‍👨‍👦‍👦 ¡Los 12 hijos de Jacob se convertirán en las 12 tribus de Israel!"
      },
      medium: {
        question: "¿Por cuántas piezas de plata fue vendido José?",
        options: [
          "10 piezas",
          "20 piezas",
          "30 piezas",
          "50 piezas"
        ],
        hint: "El precio de un esclavo",
        funFact: "💰 ¡20 piezas de plata, el precio de un esclavo en esa época!"
      },
      hard: {
        question: "¿Cómo se convierte los celos en instrumento del plan divino?",
        options: [
          "Dios aprueba los celos",
          "El mal cometido es transformado en bien por Dios",
          "Los celos son necesarios",
          "Los hermanos tenían razón"
        ],
        hint: "Se trata de la providencia divina que transforma el mal",
        funFact: "🎨 ¡Dios transforma incluso nuestras peores acciones en obra maestra de gracia!"
      }
    },

    11: {
      name: "José en la Prisión",
      challenge: "El Señor estaba con José y extendió sobre él su misericordia...",
      easy: {
        question: "¿Qué don especial tenía José?",
        options: [
          "Profetizar",
          "Interpretar sueños",
          "Curar enfermos",
          "Hablar con animales"
        ],
        hint: "Una capacidad relacionada con los sueños",
        funFact: "💭 ¡Los sueños eran considerados mensajes divinos en la antigüedad!"
      },
      medium: {
        question: "¿Qué siervos del Faraón estaban en prisión con José?",
        options: [
          "El visir y el escriba",
          "El copero y el panadero",
          "El médico y el guardia",
          "El cocinero y el jardinero"
        ],
        hint: "El que servía el vino y el que servía el pan",
        funFact: "🍷 ¡El copero probaba el vino del rey para evitar envenenamiento!"
      },
      hard: {
        question: "¿Qué nos enseña José sobre la fidelidad en la adversidad?",
        options: [
          "La injusticia es aceptable",
          "La fidelidad a Dios trasciende las circunstancias",
          "La prisión cambia a las personas",
          "Hay que vengarse"
        ],
        hint: "Se trata de permanecer fiel incluso en las pruebas",
        funFact: "⭐ ¡Incluso en prisión, José permaneció íntegro y Dios lo elevó!"
      }
    },

    12: {
      name: "Los Sueños del Faraón",
      challenge: "Siete vacas gordas... siete vacas flacas...",
      easy: {
        question: "¿Cuántas vacas flacas devoraron a las vacas gordas?",
        options: ["5", "6", "7", "8"],
        hint: "Un número perfecto",
        funFact: "🐄 ¡El número 7 simboliza la perfección y la plenitud en la Biblia!"
      },
      medium: {
        question: "¿Qué significaban los 7 años en el sueño?",
        options: [
          "7 años de guerra luego paz",
          "7 años de abundancia luego 7 años de hambre",
          "7 años de enfermedad luego salud",
          "7 años de lluvia luego sequía"
        ],
        hint: "Ciclo de abundancia y escasez",
        funFact: "🌾 ¡José salvó a Egipto y a su familia gracias a esta interpretación!"
      },
      hard: {
        question: "¿Cómo transforma la sabiduría divina las crisis?",
        options: [
          "Evitando toda crisis",
          "Dando previsión para prepararse",
          "Castigando a los malvados",
          "Enriqueciendo a los creyentes"
        ],
        hint: "Se trata de preparación y anticipación",
        funFact: "💡 ¡La sabiduría divina transforma las crisis en oportunidades de salvación!"
      }
    },

    13: {
      name: "La Reconciliación de los Hermanos",
      challenge: "Yo soy José, vuestro hermano, el que vendisteis...",
      easy: {
        question: "¿Qué puso José en el saco de Benjamín?",
        options: [
          "Oro",
          "Su anillo",
          "Su copa de plata",
          "Una carta"
        ],
        hint: "Un objeto personal precioso",
        funFact: "🏆 ¡La copa también servía para 'leer' el futuro en el agua!"
      },
      medium: {
        question: "¿Qué frase célebre dijo José sobre el mal transformado?",
        options: [
          "Os perdono",
          "Vosotros pensasteis mal contra mí, mas Dios lo encaminó a bien",
          "Olvidemos el pasado",
          "La venganza es de Dios"
        ],
        hint: "Una frase sobre la providencia divina",
        funFact: "✨ ¡Esta frase resume toda la providencia divina en nuestras vidas!"
      },
      hard: {
        question: "¿Cómo rompe el perdón los ciclos de venganza?",
        options: [
          "Olvidando el mal",
          "Liberando al ofensor y al ofendido para un nuevo comienzo",
          "Castigando primero",
          "Guardando las distancias"
        ],
        hint: "Se trata de liberación mutua",
        funFact: "🕊️ ¡El perdón de José prefigura el perdón divino universal!"
      }
    }
  }
};

export default chapter1Translations;
